export const REGISTRATION_IMAGE_MAX_BYTES = 10 * 1024 * 1024;
export const REGISTRATION_IMAGE_MAX_FILES = 5;

const SUPPORTED_IMAGE_TYPES = new Set([
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
]);
const SUPPORTED_IMAGE_EXTENSIONS = /\.(jpe?g|png|webp|gif)$/i;

export function validateRegistrationImage(file) {
  if (!file) {
    return "Seleccione una imagen.";
  }

  const hasSupportedType = SUPPORTED_IMAGE_TYPES.has(String(file.type || "").toLowerCase());
  const hasSupportedExtension = SUPPORTED_IMAGE_EXTENSIONS.test(String(file.name || ""));
  if (!hasSupportedType && !hasSupportedExtension) {
    return "Use una imagen JPG, PNG, WEBP o GIF.";
  }

  if (Number(file.size || 0) > REGISTRATION_IMAGE_MAX_BYTES) {
    return "La imagen no puede superar 10 MB.";
  }

  return null;
}

export function validateRegistrationImages(files) {
  if (files.length > REGISTRATION_IMAGE_MAX_FILES) {
    return `Puede cargar máximo ${REGISTRATION_IMAGE_MAX_FILES} imágenes.`;
  }

  for (const file of files) {
    const error = validateRegistrationImage(file);
    if (error) {
      return `${file.name || "Una imagen"}: ${error}`;
    }
  }

  return null;
}

export function calculateUploadProgress(event) {
  if (!event?.total) {
    return 0;
  }
  return Math.min(100, Math.max(0, Math.round((event.loaded * 100) / event.total)));
}
